import ApiService from '@/services/api'
import { defineStore } from 'pinia'

const ENDPOINT = '/listtemplates/'
const ITEM_ID  = 'lst_id'

export const useListtemplateStore = defineStore('listtemplates', {
  state: () => ({
    item: null,
    itemList: [],
    metaItems: null
  }),
  getters: {
    itemListById () {
      let itemsObject = {}
      for (let i = 0, len = this.itemList.length; i < len; i++) {
        itemsObject[this.itemList[i][ITEM_ID]] = this.itemList[i]
      }
      return itemsObject
    }
  },
  actions: {
    fetchItem (id, options) {
      return new Promise((resolve, reject) => {
        options = (options) ? '/' + options : ''
        if (id && id > 0) {
          ApiService.get(ENDPOINT + id + options).then((response) => {
            this.SET_ITEM(response.data.data)
            resolve(this.item)
          }).catch((error) => { reject(error) })
        } else {
          this.RESET_ITEM()
          resolve(this.item)
        }
      })
    },
    fetchItems (options) {
      return new Promise((resolve, reject) => {
        ApiService.get(ENDPOINT + (options || '')).then((response) => {
          this.metaItems = response.data.meta
          if (Object.prototype.toString.call(response.data.data) === '[object Array]') {
            this.SET_ITEMS(response.data.data)
          }
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    downloadList (id, linkid) {
      const url = (linkid) ? ENDPOINT + 'xls/' + id + '/' + linkid : ENDPOINT + 'xls/' + id
      return new Promise((resolve, reject) => {
        ApiService.get(url).then((response) => {
          resolve(response)
        }).catch((error) => { reject(error) })
      })
    },
    assocList (data) {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT + 'assoc', data).then((response) => {
          resolve(response.data)
        }).catch((error) => { reject(error) })
      })
    },
    storeItem () {
      return new Promise((resolve, reject) => {
        ApiService.post(ENDPOINT, this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    updateItem () {
      return new Promise((resolve, reject) => {
        ApiService.put(ENDPOINT + this.item[ITEM_ID], this.item).then((response) => {
          this.SET_ITEM(response.data.data)
          resolve(this.item)
        }).catch((error) => { reject(error) })
      })
    },
    destroyItem (id) {
      return new Promise((resolve, reject) => {
        this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
        ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then(() => {
          resolve('resolved')
        }).catch((error) => { reject(error) })
      })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) { this.item = item },
    SET_ITEMS (itemList) { this.itemList = itemList },
    RESET_ITEM () { this.item = {} }
  }
})
